"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const progress_bar_default_styles_1 = __importDefault(require("./progress-bar-default.styles"));
const b = b_1.default.with('progress-bar');
function ProgressBarDefault({ percent = 0 }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b({ preset: 'default' }), style: { width: `${percent}%` } }, { children: (0, jsx_runtime_1.jsx)(react_1.Global, { styles: progress_bar_default_styles_1.default }) })));
}
exports.default = ProgressBarDefault;
